module.exports = __webpack_public_path__ + "static/LinkedIn-87e58c3278af01c648997342d16208a2.png";